// AI Generated file
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { DateTimeService } from '@client/app/services/date-time/date-time.service';

@Pipe({
    name: 'userDate',
    standalone: false,
})
export class UserDatePipe implements PipeTransform {
    constructor (
        private datePipe: DatePipe,
        private dateTimeService: DateTimeService,
    ) {}

    transform (date: any, format?: string): string {
        if (!date) {
            return '';
        }
        format = format || 'll';
        // TODO-NOW: Old implementation uses
        // return $filter('amDateFormat')(date, customFormats(format));
        const momentFormat = this.customFormats(format);
        return this.dateTimeService.format(date, momentFormat);
        // return this.datePipe.transform(date, angularFormat);
    }

    private customFormats (format: string): string {
        switch (format) {
            case 'fullDate':
                // Angular format: EEEE, MMMM d, y
                // Moment.js format: dddd, MMMM D, YYYY
                // Note: Angular 'd' = day of month, Moment 'D' = day of month
                //       Angular 'y' = year, Moment 'YYYY' = year
                return 'dddd, MMMM D, YYYY';
            default:
                return format;
        }
    }
}
